import * as Sentry from '@sentry/browser';
import { auth } from '../../constants/firebaseModular';

export const requestDomainDiscount = async (domain: string, uid: string, product: string) => {
  const url = `${import.meta.env.VITE_CLOUDFUNCTIONS_URI}/commerceApi/discountCodes?domain=${domain}&uid=${uid}&product=${product}`;
  const token = await auth.currentUser?.getIdToken();
  if (!token) {
    throw new Error('User is not authenticated');
  }

  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const res = await fetch(url, {
    method: 'POST',
    headers: myHeaders,
  });

  const data = await res.json();

  if (res.status !== 200) {
    const errorMessage = data.error || 'Unable to process discount request. Please try again or contact support.';
    Sentry.captureException(new Error(`requestDomainDiscount failed: ${res.status} - ${errorMessage}`));
    throw new Error(errorMessage);
  }

  return data;
};
